import { ReactElement, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import capitalize from 'lodash/capitalize'

import { ThankYouForwardEventsProps as Props } from './types'

import TransmissionService from 'modules/transmission/service'
import settings from 'common/helpers/settings/.'
import DateHelper from 'common/helpers/date'
import { NextTransmissionInfo } from 'modules/transmission/types'

import './thankYouForwardEvents.scss'

const ThankYouForwardEvents = ({ transmissionCode }: Props) => {
  const { t } = useTranslation()

  const [nextTransmissions, setNextTransmissions] = useState<NextTransmissionInfo[]>([])

  useEffect(
    () => {
      const fetchData = async () => {
        try {
          const response = await TransmissionService.getNextTransmissions(transmissionCode)

          setNextTransmissions(response)
        } catch (error) {
          console.error(error)
        }
      }

      fetchData()
    },
    [transmissionCode]
  )

  const renderTransmission = (transmission: NextTransmissionInfo): ReactElement<HTMLLIElement> => {
    const { code, name, largeThumbnailLink, liveStartAt } = transmission
    const formattedDate = capitalize(t('thank-form.next-event-date', {
      weekday: DateHelper.format(liveStartAt, 'dddd'),
      date: DateHelper.format(liveStartAt, 'L'),
      time: DateHelper.format(liveStartAt, 'LT')
    }))

    return (
      <li className="event-item" key={code}>
        <a className="link" target="_blank" href={`${settings.app.live}/${code}`} rel="noreferrer noopener">
          <div className="thumb-container">
            <img className="thumb" src={largeThumbnailLink} alt={name} />
          </div>
          <div className="details-container">
            <span className="transmission-name" title={name}>{name}</span>
            <span className="transmission-date" title={formattedDate}>{formattedDate}</span>
          </div>
        </a>
      </li>
    )
  }

  const renderSection = () => (
    <section className="thank-you-forward-events">
      <span className="title">{t('thank-form.next-events')}</span>
      <ul className="events-list">{nextTransmissions.map(renderTransmission)}</ul>
    </section>
  )

  return nextTransmissions.length > 0 ? renderSection() : null
}

export default ThankYouForwardEvents
